import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProcessRefundInitFormResponseModel } from '../model/ProcessRefundInitFormResponseModel';
import { RefundReportDetailsWrapperResponse } from '../model/RefundReportDetailsWrapperResponse';
import { FileResponseModel } from '../model/FileResponseModel';

@Injectable({
  providedIn: 'root'
})
export class ProcessRefundService {
  
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

  initProcessRefundForm() {
    return this.httpClient.get<ProcessRefundInitFormResponseModel>(ApiUrls.processRefundInitFormUrl);
  }

  initiateRefundProcess(key: number){
    console.log("Service Layer called:", key);
    return this.httpClient.get<FileResponseModel>(ApiUrls.initiateRefundProcess.replace(`{key}`, key.toString()));
  }

  initWithLottery(key: number){
    return this.httpClient.get<RefundReportDetailsWrapperResponse>(
      ApiUrls.refundReportDetailsInIt.replace('{lotteryKey}', key.toString()));
  }

  getRefundReportFile(key: number){
    return this.httpClient.get<FileResponseModel>(ApiUrls.getRefundReport.replace('{key}', key.toString()));
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
}
